import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "./Logo";

export default function Header() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const linkBase =
    "font-clash text-[13px] tracking-[-0.02em] whitespace-nowrap px-[11px] py-[11px] transition-colors";
  const navLinkClass = ({ isActive }: { isActive: boolean }) =>
    `${linkBase} ${isActive ? "text-[#010f1f]" : "text-[#b9b9b9] hover:text-[#010f1f]"}`;
  const divider = (
    <span className="font-space font-medium text-[13px] text-[#010f1f] tracking-[-0.05em] px-[11px]">|</span>
  );

  return (
    <header className="sticky top-0 z-50 w-full bg-white">
      <div className="mx-auto flex h-[68.7px] w-full max-w-page items-center px-5 md:px-[42px] py-[15px]">
        <Link to="/" aria-label="KAG Defense home" className="shrink-0">
          <Logo />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex flex-1 items-center justify-center gap-[3px]">
          <NavLink to="/who-we-are" className={navLinkClass}>{t("nav.whoWeAre")}</NavLink>
          {divider}
          <NavLink to="/what-we-do" className={navLinkClass}>{t("nav.whatWeDo")}</NavLink>
          {divider}
          <NavLink to="/governance" className={navLinkClass}>{t("nav.governance")}</NavLink>
          {divider}
          <NavLink to="/contact" className={navLinkClass}>{t("nav.contact")}</NavLink>
        </nav>

        {/* Mobile spacer */}
        <div className="flex-1 lg:hidden" />

        {/* Lang toggle (desktop) */}
        <div className="hidden lg:flex items-center shrink-0">
          <button
            type="button"
            onClick={() => i18n.changeLanguage("en")}
            className={`${linkBase} ${i18n.language?.startsWith("en") ? "text-black" : "text-[#8e8e8e]"}`}
          >
            {t("lang.en")}
          </button>
          <span className="font-space font-medium text-[13px] text-[#8e8e8e] tracking-[-0.05em] px-[11px]">|</span>
          <button
            type="button"
            onClick={() => i18n.changeLanguage("al")}
            className={`${linkBase} ${i18n.language?.startsWith("al") ? "text-black" : "text-[#8e8e8e]"}`}
          >
            {t("lang.al")}
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle navigation"
          aria-expanded={open}
          className="lg:hidden inline-flex items-center justify-center w-[19px] h-[17px] shrink-0"
        >
          <svg viewBox="0 0 19 17" className="w-full h-full" aria-hidden="true">
            <rect x="0" y="2" width="19" height="1.6" rx="0.8" fill="#010f1f" />
            <rect x="0" y="8" width="19" height="1.6" rx="0.8" fill="#010f1f" />
            <rect x="0" y="14" width="19" height="1.6" rx="0.8" fill="#010f1f" />
          </svg>
        </button>
      </div>

      {/* Mobile menu drawer */}
      {open && (
        <div className="lg:hidden border-t border-black/5 bg-white">
          <nav className="mx-auto w-full max-w-page flex flex-col px-5 py-3">
            <NavLink to="/who-we-are" onClick={() => setOpen(false)} className={({ isActive }) => `py-3 font-clash text-[14px] ${isActive ? "text-[#010f1f]" : "text-[#b9b9b9]"}`}>
              {t("nav.whoWeAre")}
            </NavLink>
            <NavLink to="/what-we-do" onClick={() => setOpen(false)} className={({ isActive }) => `py-3 font-clash text-[14px] ${isActive ? "text-[#010f1f]" : "text-[#b9b9b9]"}`}>
              {t("nav.whatWeDo")}
            </NavLink>
            <NavLink to="/governance" onClick={() => setOpen(false)} className={({ isActive }) => `py-3 font-clash text-[14px] ${isActive ? "text-[#010f1f]" : "text-[#b9b9b9]"}`}>
              {t("nav.governance")}
            </NavLink>
            <NavLink to="/contact" onClick={() => setOpen(false)} className={({ isActive }) => `py-3 font-clash text-[14px] ${isActive ? "text-[#010f1f]" : "text-[#b9b9b9]"}`}>
              {t("nav.contact")}
            </NavLink>
            <div className="flex items-center gap-3 mt-2 pt-3 border-t border-black/5">
              <button
                type="button"
                onClick={() => i18n.changeLanguage("en")}
                className={`font-clash text-[13px] ${i18n.language?.startsWith("en") ? "text-black" : "text-[#8e8e8e]"}`}
              >
                {t("lang.en")}
              </button>
              <span className="text-[#8e8e8e]">|</span>
              <button
                type="button"
                onClick={() => i18n.changeLanguage("al")}
                className={`font-clash text-[13px] ${i18n.language?.startsWith("al") ? "text-black" : "text-[#8e8e8e]"}`}
              >
                {t("lang.al")}
              </button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
